import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';

export const getFileIcon = (filename: string | undefined) => {
  const extension = getFileExtension(filename);

  switch (extension) {
    case 'pdf':
      return PictureAsPdf;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'webp':
      return ImageIcon;
    case 'txt':
      return DescriptionIcon;
    default:
      return InsertDriveFileIcon;
  }
};

const getFileExtension = (filename: string | undefined): string => {
  if (!filename) return '';
  const parts = filename.split('.');
  return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
};
